"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Box_1 = require("./Box");
const DownloadIcon = (props) => {
    const svgStyle = Object.assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" });
    return (React.createElement(Box_1.Box, Object.assign({ position: "relative", width: 18, height: 18 }, props),
        React.createElement("svg", { viewBox: "0 0 18 18", style: svgStyle, fill: "currentColor" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3H9.006L10.979 5.002H15V14.996H3V3ZM3.99 4V13.996H14.01V6.002H10.545L8.601 4H3.99ZM9.566 11.279L11.046 9.81L11.706 10.61L9 13.257L6.261 10.382L6.972 9.65L8.516 11.318L8.47 11.25V6.56L9.566 6.578V11.278V11.279Z" }))));
};
DownloadIcon.displayName = 'DownloadIcon';
exports.default = DownloadIcon;
//# sourceMappingURL=DownloadIcon.js.map